/* Tur 23 EK3B (13 Ekim): Kordon Panosu davranisi - referans 'Kordon Panosu — davranış' bolumunun betikle kopyasi.
   Prova parcalari cikarildi: __agbSimdi (sahte saat) ve AGBant.oynat (kalkisi yeniden oynat). */
/* =====================================================================
   Kordon Panosu — davranış (önek: agb). Bağımlılık yok, ~3 KB.
   İki şey yapar, ikisi de sessiz:
     1. Kalkış — oturumun ilk sayfasında boş kanatlar Türk alfabesi
                 sırasıyla birkaç harf geçip ÜCRETSİZ KARGO'ya oturur
                 (~0,7 sn). Ufuk çizgisi aynı anda yanar.
     2. Ufuk   — alt çizgideki parıltı İzmir'de güneşin o anki yerinde.
     3. Körfez — (yalnız telefon, .agb--korfez) zeminde gravür şeridi; gündüz/gece
                 İzmir saatine göre, güneş/ay ufkun üstünde yay çizer; ilk ziyarette
                 uzaktan bir vapur geçer.
     4. Kapı   — (yalnız masaüstü) İZMİR · ALSANCAK mağazaya gider; üzerine gelince vitrin kartı.
   Hareket azaltma, yüksek kontrast, JS yok, arka plan sekmesi → son hal.
   Yalnız transform + opacity (Web Animations API).
   ===================================================================== */
(function () {
  'use strict';

  var DRUM = ' ABCÇDEFGĞHIİJKLMNOÖPRSŞTUÜVYZ';   // tambur sırası (boşluk = boş kanat)
  var KAC  = [3, 2, 4, 3, 2, 4, 3, 3, 4, 2, 3, 4, 2, 3]; // hücre başına kanat sayısı (≥ 2)
  var DUS  = 'cubic-bezier(.55, 0, .85, .55)';       // düşen üst kanat: yerçekimi (UI eğrisi değil, fizik)
  var KALK = 'cubic-bezier(.33, .28, .67, .62)';     // inen alt kanat: neredeyse düz
  var IZMIR = { lat: 38.4237, lon: 27.1428, tz: 3 }; // Türkiye kalıcı UTC+3
  var KEY = 'agb:kalkis';

  var D = document.documentElement;
  var mm = function (q) { try { return window.matchMedia(q).matches; } catch (e) { return false; } };
  var SAKIN = D.getAttribute('data-ag-calm') === '1' || mm('(prefers-reduced-motion: reduce)') || mm('(forced-colors: active)');
  var simdi = function () { return Date.now(); };

  /* kanat süresi: ilk 90, ikinci 72, aradakiler 62, son 80 ms (tambur hızlanır, son kanatta yavaşlar) */
  function sure(m, k) { return m === 0 ? 90 : m === k - 1 ? 80 : m === 1 ? 72 : 62; }

  /* ------------------------------------------------------------ kanat */
  function parca(h) {
    return h._p || (h._p = {
      u: h.querySelector('.agb-u i'), ai: h.querySelector('.agb-a i'),
      y1: h.querySelector('.agb-y1'), y1i: h.querySelector('.agb-y1 i'), y1g: h.querySelector('.agb-y1 .agb-g'),
      y2: h.querySelector('.agb-y2'), y2i: h.querySelector('.agb-y2 i'), y2g: h.querySelector('.agb-y2 .agb-g')
    });
  }
  function bitir(h) {
    var p = parca(h);
    (h._an || []).forEach(function (a) { try { a.cancel(); } catch (e) {} });
    h._an = [];
    p.y1.style.visibility = p.y2.style.visibility = '';
    if (h._son != null) p.ai.textContent = h._son;
  }
  /* Tek kanat: üst yaprak (eski harf) yerçekimiyle düşer, alt yaprak (yeni harf) iner. */
  function kanat(h, eski, yeni, d, sek, olcu) {
    bitir(h);
    var p = parca(h), gm = olcu.gm;
    var td = Math.round(d * .65), ti = d - td, pr = 'perspective(' + olcu.P + 'px) rotateX(';
    p.u.textContent = yeni;   p.ai.textContent = eski;
    p.y1i.textContent = eski; p.y2i.textContent = yeni;
    p.y1.style.visibility = p.y2.style.visibility = 'visible';
    h._son = yeni;
    h._an = [
      p.y1.animate([{ transform: pr + '0deg)' }, { transform: pr + '-90deg)' }], { duration: td, easing: DUS, fill: 'forwards' }),
      p.y1g.animate([{ opacity: 0 }, { opacity: gm }], { duration: td, easing: DUS, fill: 'forwards' }),
      p.y2.animate([{ transform: pr + '90deg)' }, { transform: pr + '0deg)' }], { duration: ti, delay: td, easing: KALK, fill: 'both' }),
      p.y2g.animate([{ opacity: gm * .6 }, { opacity: 0 }], { duration: ti, delay: td, easing: KALK, fill: 'both' })
    ];
    if (sek) {                                      // son kanat hafifçe çarpıp oturur
      h._an.push(p.y2.animate([{ transform: pr + '0deg)' }, { transform: pr + sek + 'deg)' }, { transform: pr + '0deg)' }],
        { duration: 80, delay: d, easing: 'ease-out' }));
      h._an.push(p.y2g.animate([{ opacity: 0 }, { opacity: .08 }, { opacity: 0 }], { duration: 80, delay: d }));
    }
  }

  /* ------------------------------------------------------------ 1. kalkış */
  function bosalt(hucreler) {                      // senkron: harfler hiç görünmeden boş kanat
    hucreler.forEach(function (h) { var p = parca(h); p.u.textContent = p.ai.textContent = ' '; h._son = ' '; });
  }
  function kalkis(bant, hucreler) {
    var enGec = 0, zam = [];
    var olcu = { P: Math.round((hucreler[0] ? hucreler[0].offsetHeight : 20) * 5.4),
                 gm: parseFloat(getComputedStyle(bant).getPropertyValue('--agb-gol-max')) || .45 };
    var u = bant.querySelector('.agb-ufuk');
    bant.removeAttribute('data-agb-karanlik');
    if (u && u.animate) u.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 700, easing: 'cubic-bezier(.23, 1, .32, 1)' });

    hucreler.forEach(function (h, i) {
      var hedef = (h.getAttribute('data-c') || ' ').toLocaleUpperCase('tr-TR');
      var t = DRUM.indexOf(hedef);
      if (hedef === ' ' || t < 0) { var p = parca(h); p.u.textContent = p.ai.textContent = hedef; h._son = hedef; return; }
      var k = KAC[i % KAC.length], an = 60 + i * 24, onceki = ' ';
      for (var m = 0; m < k; m++) {
        var c = DRUM.charAt((t - (k - 1 - m) + DRUM.length * 2) % DRUM.length), d = sure(m, k);
        zam.push(setTimeout(kanat.bind(null, h, onceki, c, d, m === k - 1 ? 3.5 : 0, olcu), an));
        an += d; onceki = c;
      }
      enGec = Math.max(enGec, an + 80);
    });
    zam.push(setTimeout(function () {
      hucreler.forEach(bitir);
      bant.dispatchEvent(new CustomEvent('agb:indi', { bubbles: true, detail: { ms: enGec } }));
    }, enGec + 20));
    bant._zam = zam;
  }

  /* ------------------------------------------------------------ 2. ufuk */
  function gunes(n, dogus) {                      // NOAA yaklaşık; İzmir; dakika (UTC)
    var r = Math.PI / 180, g = 2 * Math.PI / 365 * (n - 1);
    var eq = 229.18 * (.000075 + .001868 * Math.cos(g) - .032077 * Math.sin(g) - .014615 * Math.cos(2 * g) - .040849 * Math.sin(2 * g));
    var de = .006918 - .399912 * Math.cos(g) + .070257 * Math.sin(g) - .006758 * Math.cos(2 * g) + .000907 * Math.sin(2 * g) - .002697 * Math.cos(3 * g) + .00148 * Math.sin(3 * g);
    var ha = Math.acos(Math.cos(90.833 * r) / (Math.cos(IZMIR.lat * r) * Math.cos(de)) - Math.tan(IZMIR.lat * r) * Math.tan(de)) / r;
    return 720 - 4 * (IZMIR.lon + (dogus ? ha : -ha)) - eq;
  }
  function gun(ms) {                              // İzmir yerel günü için doğuş/batış (ms)
    var yerel = new Date(ms + IZMIR.tz * 36e5);
    var y = yerel.getUTCFullYear(), gece0 = Date.UTC(y, yerel.getUTCMonth(), yerel.getUTCDate());
    var n = Math.round((gece0 - Date.UTC(y, 0, 0)) / 864e5);
    return { dog: gece0 + gunes(n, true) * 6e4, bat: gece0 + gunes(n, false) * 6e4 };
  }
  function saat(ms) {
    var t = new Date(Math.round(ms / 6e4) * 6e4 + IZMIR.tz * 36e5);
    return ('0' + t.getUTCHours()).slice(-2) + ':' + ('0' + t.getUTCMinutes()).slice(-2);
  }
  function ufuk(bant) {
    /* Kesintisiz döngü: gündüz soldan sağa (doğuş → batış); batıştan sonra 40 dk sağda kızıllık
       söner; gece sönük ışık sağdan sola döner; şafaktan önceki 30 dk solda aydınlanır. */
    var t = simdi(), b = gun(t), x, i, DK = 6e4, kizil = 40 * DK, safak = 30 * DK;
    var kis = function (v) { return Math.min(1, Math.max(0, v)); };
    var gunduz = t >= b.dog && t < b.bat, alaca = false;
    if (gunduz) {
      x = (t - b.dog) / (b.bat - b.dog);
      i = .6 + .3 * kis(1 - (b.bat - t) / (75 * DK));                // son 75 dk: altın saat
    } else {
      var batti = t >= b.bat ? b.bat : gun(t - 864e5).bat;
      var dogar = t >= b.bat ? gun(t + 864e5).dog : b.dog;
      if (t - batti < kizil) { x = 1; i = .9 - .45 * ((t - batti) / kizil); alaca = true; }
      else if (dogar - t < safak) { x = 0; i = .45 + .15 * (1 - (dogar - t) / safak); alaca = true; }
      else { x = 1 - (t - batti - kizil) / (dogar - safak - batti - kizil); i = .45; }
    }
    bant.style.setProperty('--agb-gx', (x * 100).toFixed(2) + '%');
    bant.style.setProperty('--agb-gr', x.toFixed(4));               // aynı yer, birimsiz (Körfez)
    bant.style.setProperty('--agb-gi', i.toFixed(3));
    if (bant.classList.contains('agb--korfez')) {
      /* gündüz: bronz gravür + güneş; gece: şehir ışıkları + ay; alacakaranlıkta ışık ufkun altında */
      bant.setAttribute('data-dunya', gunduz ? 'gunduz' : 'gece');
      bant.style.setProperty('--agk-alt', (Math.sin(Math.PI * x) * (gunduz ? 1 : .75)).toFixed(3));
      if (alaca) bant.setAttribute('data-agk-alaca', ''); else bant.removeAttribute('data-agk-alaca');
      /* Tur 23 EK9 D076: gunduz plakasina saate gore ton (sabah: doğuştan 3 sa, akşam: batıştan önceki 2 sa); yalnız gravür */
      var ton = !gunduz ? 'gece' : t - b.dog < 3 * 36e5 ? 'sabah' : b.bat - t < 2 * 36e5 ? 'aksam' : 'ogle';
      if (window.agOz && window.agOz('D076')) bant.setAttribute('data-agk-ton', ton); else bant.removeAttribute('data-agk-ton');
    }
  }

  /* ------------------------------------------------------------ 3. körfez */
  function pencere(bant) {                         // pencere, panonun bittiği yerden başlar
    var p = bant.querySelector('.agb-pano');
    if (!p || !bant.classList.contains('agb--korfez')) return;
    var r = p.getBoundingClientRect(), b = bant.getBoundingClientRect();
    if (r.width) bant.style.setProperty('--agk-ps', Math.round(r.right - b.left + 14) + 'px');
  }
  function vapur(bant, gecikme) {                  // ilk ziyarette bir kez, sağdan pencerenin başına
    var v = bant.querySelector('.agk-vapur');
    if (!v || !v.animate || bant.clientWidth >= 1024) return;
    var w = bant.clientWidth, ps = parseFloat(bant.style.getPropertyValue('--agk-ps')) || w * .5;
    if (v._an) v._an.cancel();
    v._an = v.animate([
      { transform: 'translateX(' + (w + 4) + 'px)', opacity: 1 },
      { opacity: 1, offset: .86 },
      { transform: 'translateX(' + Math.round(ps - 30) + 'px)', opacity: 0 }
    ], { duration: Math.round(Math.max(9000, (w - ps) * 95)), delay: gecikme || 0, easing: 'linear' });
  }

  /* Tur 23 EK10 Faz 2 S076 Ay evresi: gece saatlerinde (bant data-dunya=gece) ay noktasi gercek evreyi cizer; D071 dugmesine
     dokunus gece kart acar (evre adi, sonraki dolunay, 6 gun), uzun basis (500 ms) dunyayi degistirir. Anahtar S076. */
  var AY_AD = { yeni: 'Yeni ay', ilk: '\u0130lk d\u00f6rd\u00fcn', dolunay: 'Dolunay', son: 'Son d\u00f6rd\u00fcn' };
  var AYLAR = ['Ocak', '\u015eubat', 'Mart', 'Nisan', 'May\u0131s', 'Haziran', 'Temmuz', 'A\u011fustos', 'Eyl\u00fcl', 'Ekim', 'Kas\u0131m', 'Aral\u0131k'];
  function ayYol(e, r) {
    var w = Math.cos(2 * Math.PI * e) * r, sag = e < .5;
    return 'M0,' + (-r) + ' A' + r + ',' + r + ' 0 0 ' + (sag ? 1 : 0) + ' 0,' + r + ' A' + Math.abs(w).toFixed(2) + ',' + r + ' 0 0 ' + ((w > 0) === sag ? 0 : 1) + ' 0,' + (-r) + 'Z';
  }
  function aySvg(e, r, cls) {
    return '<svg class="' + cls + '" viewBox="' + (-r - 1) + ' ' + (-r - 1) + ' ' + (2 * r + 2) + ' ' + (2 * r + 2) + '" aria-hidden="true" focusable="false"><circle r="' + r + '" class="agk-ay__karanlik"/><path d="' + ayYol(e, r) + '" class="agk-ay__isik"/></svg>';
  }
  function ayAdi(a) { return AY_AD[a.ad] || (a.ad === 'hilal' ? (a.evre < .5 ? 'B\u00fcy\u00fcyen hilal' : 'K\u00fc\u00e7\u00fclen hilal') : (a.evre < .5 ? 'B\u00fcy\u00fcyen ay' : 'K\u00fc\u00e7\u00fclen ay')); }
  function ayKur(bant, dd) {
    var Z = window.AGZaman;
    if (!Z || !Z.ayEvresi || !(window.agOz && window.agOz('S076'))) return;
    var isik = bant.querySelector('.agk-isik'), kart = null;
    function gece() { return bant.getAttribute('data-dunya') === 'gece'; }
    function ciz() { if (!isik) return; if (gece()) { isik.classList.add('agk-isik--ay'); isik.innerHTML = aySvg(Z.ayEvresi(Z.simdi()).evre, 5, 'agk-ay'); } else { isik.classList.remove('agk-isik--ay'); isik.innerHTML = ''; } }
    ciz(); bant._ayIv = setInterval(ciz, 3e5);
    function kapat() { if (kart) { kart.remove(); kart = null; dd.setAttribute('aria-expanded', 'false'); dd.focus({ preventScroll: true }); } }
    function ac() {
      var t = Z.simdi(), a = Z.ayEvresi(t), gunler = Z.gunler || [];
      var kalan = ((.5 - a.evre) % 1 + 1) % 1 * 29.530588853, dl = new Date(t.getTime() + kalan * 864e5);
      var dizi = ''; for (var i = 0; i < 6; i++) { var g = new Date(t.getTime() + i * 864e5); dizi += '<li>' + aySvg(Z.ayEvresi(g).evre, 7, 'agk-aykart__mini') + '<span>' + (i ? ['Paz', 'Pzt', 'Sal', '\u00c7ar', 'Per', 'Cum', 'Cmt'][g.getUTCDay()] : 'Bug\u00fcn') + '</span></li>'; }
      kart = document.createElement('div'); kart.className = 'agk-aykart'; kart.setAttribute('role', 'dialog'); kart.setAttribute('aria-label', 'Ay evresi');
      kart.innerHTML = '<button type="button" class="agk-aykart__kapat" aria-label="Kapat">\u00d7</button>' + aySvg(a.evre, 18, 'agk-aykart__ay') +
        '<p class="agk-aykart__ad">' + ayAdi(a) + '</p><p class="agk-aykart__dl">' + (a.dolunay ? 'Bu gece dolunay' : 'Sonraki dolunay: ' + dl.getUTCDate() + ' ' + AYLAR[dl.getUTCMonth()] + ' ' + (gunler[dl.getUTCDay()] || '')) + '</p>' +
        '<ol class="agk-aykart__dizi">' + dizi + '</ol><button type="button" class="agk-aykart__dunya" data-ag-mode-toggle>' + (document.documentElement.getAttribute('data-ag-mode') === 'night' ? 'G\u00fcnd\u00fcz\'e ge\u00e7' : 'Gece\'ye ge\u00e7') + '</button>';
      kart.style.top = Math.max(8, Math.round(bant.getBoundingClientRect().bottom + 6)) + 'px';
      document.body.appendChild(kart); dd.setAttribute('aria-expanded', 'true');
      kart.querySelector('.agk-aykart__kapat').focus({ preventScroll: true });
      kart.addEventListener('click', function (e) { if (e.target.closest('.agk-aykart__kapat')) kapat(); else if (e.target.closest('[data-ag-mode-toggle]')) setTimeout(kapat, 0); });
    }
    bant._ayEsc = function (e) { if (e.key === 'Escape' && kart) kapat(); };
    document.addEventListener('keydown', bant._ayEsc);
    var bas = 0, uzun = false, zz = null;
    dd.addEventListener('pointerdown', function () { uzun = false; clearTimeout(zz); zz = setTimeout(function () { uzun = true; }, 500); });
    dd.addEventListener('pointerup', function () { clearTimeout(zz); });
    dd.addEventListener('click', function (e) {
      if (!gece() || uzun) { uzun = false; return; }
      e.preventDefault(); e.stopImmediatePropagation();
      if (kart) kapat(); else ac();
    }, true);
    dd.setAttribute('aria-haspopup', 'dialog');
  }

  /* Tur 23 EK10 Faz 2 S080 Gun dogumu acilisi: gun dogumundan sonraki 90 dk icinde gunun ilk ziyaretinde gunes ufkun altindan bir
     kez yukselir (1,2 sn, yalniz transform); bant harf donusuyle ayni anda oynamaz (ilk ziyarette harfler bitince). Gunde bir kez
     (localStorage agb:dogus). Hareket azaltmada gunes yerinde durur. Bandin yuksekligi degismez (kayma yok). Anahtar S080. */
  function dogus(bant, ilk) {
    if (!(window.agOz && window.agOz('S080')) || !bant.classList.contains('agb--korfez') || bant.clientWidth >= 1024) return;
    var t = simdi(), b = gun(t), gk = saat(b.dog) + '|' + new Date(t + IZMIR.tz * 36e5).toISOString().slice(0, 10);
    if (t < b.dog || t - b.dog > 90 * 6e4) return;
    try { if (localStorage.getItem('agb:dogus') === gk) return; localStorage.setItem('agb:dogus', gk); } catch (e) { return; }
    var isik = bant.querySelector('.agk-isik'); if (!isik || SAKIN || !isik.animate) return;
    isik.animate([{ transform: 'translateY(22px)', opacity: .2 }, { transform: 'translateY(0)', opacity: 1 }],
      { duration: 1200, delay: ilk ? 2600 : 300, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' });
    bant.setAttribute('data-agk-dogus', '');
  }

  /* ------------------------------------------------------------ kurulum */
  function kur(bant, ilk) {
    if (bant._agb) return;
    bant._agb = true;
    var hucreler = [].slice.call(bant.querySelectorAll('.agb-h'));
    var tazele = function () { if (!document.hidden) ufuk(bant); };
    var iv = setInterval(tazele, 3e5);
    document.addEventListener('visibilitychange', tazele);
    window.addEventListener('pageshow', tazele);
    bant._sok = function () {                       // tema düzenleyicide bölüm yenilenince
      clearInterval(iv); (bant._zam || []).forEach(clearTimeout);
      document.removeEventListener('visibilitychange', tazele); window.removeEventListener('pageshow', tazele);
      if (bant._ro) bant._ro.disconnect();
      clearInterval(bant._ayIv); if (bant._ayEsc) document.removeEventListener('keydown', bant._ayEsc);
      bant._agb = false;
    };
    ufuk(bant);
    /* Tur 23 EK9 D071: bant noktasi dunya dugmesi - etiket secili dunyaya gore; dokununca nokta ufka iner ve geri cikar */
    var dd = bant.querySelector('[data-agk-dunya]');
    if (dd) ayKur(bant, dd);
    if (dd) {
      var etiket = function () { dd.setAttribute('aria-label', document.documentElement.getAttribute('data-ag-mode') === 'night' ? 'Gündüz\'e geç' : 'Gece\'ye geç'); };
      etiket(); document.addEventListener('ag:mode', etiket);
      dd.addEventListener('click', function () {
        if (SAKIN) return; bant.removeAttribute('data-agk-iniyor'); void bant.offsetWidth; bant.setAttribute('data-agk-iniyor', '');
        setTimeout(function () { bant.removeAttribute('data-agk-iniyor'); }, 650);
      });
    }
    if (bant.classList.contains('agb--korfez')) {
      pencere(bant);
      if (window.ResizeObserver) { bant._ro = new ResizeObserver(function () { pencere(bant); }); bant._ro.observe(bant); }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { pencere(bant); });
    }
    dogus(bant, ilk);
    if (!ilk) return;
    /* Yigit 24 Ekim: gar tabelasi (split-flap) hicbir yerde yok - ilk ziyarette harf donusu yok, yalniz vapur gecer */
    vapur(bant, 900); return;
    bosalt(hucreler);
    bant.setAttribute('data-agb-karanlik', '');
    var bekle = document.fonts && document.fonts.ready
      ? Promise.race([document.fonts.ready, new Promise(function (r) { setTimeout(r, 150); })]) : Promise.resolve();
    bekle.then(function () { kalkis(bant, hucreler); pencere(bant); vapur(bant, 900); });
  }

  /* ------------------------------------------------------------ 4. mağaza kapısı (masaüstü) */
  function kapi(kap) {
    var a = kap.querySelector('.agk-kapi'), kart = kap.querySelector('.agk-kart');
    if (!a || !kart || a._agk) return;
    a._agk = true;
    var vid = kart.querySelector('video'), z;
    function ac() {
      clearTimeout(z);
      if (vid && !vid.getAttribute('src')) { vid.poster = vid.getAttribute('data-poster'); vid.src = vid.getAttribute('data-src'); }
      kart.setAttribute('data-acik', ''); a.setAttribute('data-acik', '');
      if (vid && !SAKIN) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
    }
    function kapa() { kart.removeAttribute('data-acik'); a.removeAttribute('data-acik'); if (vid) vid.pause(); }
    var ince = mm('(hover: hover) and (pointer: fine)');
    [a, kart].forEach(function (el) {
      if (ince) {
        el.addEventListener('mouseenter', function () { clearTimeout(z); z = setTimeout(ac, 120); });
        el.addEventListener('mouseleave', function () { clearTimeout(z); z = setTimeout(kapa, 160); });
      }
    });
    a.addEventListener('focus', function () { var fv = true; try { fv = a.matches(':focus-visible'); } catch (e) {} if (fv) ac(); });
    a.addEventListener('blur', function () { z = setTimeout(kapa, 160); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') kapa(); });
  }

  function basla() {
    [].forEach.call(document.querySelectorAll('.agb-kap'), kapi);
    var hepsi = [].slice.call(document.querySelectorAll('[data-agb]'));
    var gorunen = hepsi.filter(function (b) { var r = b.getClientRects(); return r.length && r[0].bottom > 0; });
    var ilk = D.hasAttribute('data-agb-kalkis') && !SAKIN && !!Element.prototype.animate && !document.hidden && gorunen.length > 0;
    /* Tur 23 EK9 §4.5/§4.7: harf donusu yalniz cihazdaki ilk ziyarette, ilk mesajda; ozel gunde ve Outlet'te (ilk mesaj pano degil) yok */
    if (ilk && ((window.AGZaman && window.AGZaman.ozelGun()) || hepsi.some(function (b) { return b.getAttribute('data-agb-sayfa') === 'outlet'; }))) ilk = false;
    if (ilk) { try { localStorage.setItem(KEY, '1'); } catch (e) {} }
    hepsi.forEach(function (b) { kur(b, ilk && gorunen.indexOf(b) > -1); });
    D.removeAttribute('data-agb-kalkis');           // her kanat ya boşaltıldı ya son halinde
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla); else basla();

  /* Shopify tema düzenleyicisi */
  document.addEventListener('shopify:section:unload', function (e) {
    [].forEach.call(e.target.querySelectorAll('[data-agb]'), function (b) { if (b._sok) b._sok(); });
  });
  document.addEventListener('shopify:section:load', function (e) {
    [].forEach.call(e.target.querySelectorAll('[data-agb]'), function (b) { kur(b, false); });
    [].forEach.call(e.target.querySelectorAll('.agb-kap'), kapi);
  });

  window.AGBant = { ufuk: ufuk, gun: gun, saat: saat, sakin: function () { return SAKIN; } };
})();

/* FORM D070 Kaydirinca Incelen: asagi kaydirinca 2 px altin Ufuk cizgisi (nokta gunesin / ayin yeri), yukari kaydirinca kalkar. */
(function () {
  'use strict';
  if (!document.querySelector('[data-agb]') || !(window.agOz && window.agOz('D070'))) return;
  var c = document.createElement('div'); c.className = 'agb-cizgi'; c.setAttribute('aria-hidden', 'true'); c.innerHTML = '<i></i>';
  document.body.appendChild(c);
  var n = c.firstChild, y0 = window.scrollY, kare = false;
  function yer() {
    var Z = window.AGZaman; if (!Z || !Z.gunes) return;
    var d = Z.simdi(), su = d.getUTCHours() * 60 + d.getUTCMinutes(), g = Z.gunes(d), gun = su >= g.dogusDk && su < g.batisDk;
    var f = gun ? (su - g.dogusDk) / (g.batisDk - g.dogusDk) : ((su - g.batisDk + 1440) % 1440) / (1440 - (g.batisDk - g.dogusDk));
    n.style.left = (Math.max(0, Math.min(1, f)) * 100).toFixed(1) + '%'; c.classList.toggle('agb-cizgi--gece', !gun);
  }
  yer(); if (window.AGZaman && window.AGZaman.her) window.AGZaman.her(yer);
  window.addEventListener('scroll', function () {
    if (kare) return; kare = true;
    requestAnimationFrame(function () {
      kare = false; var y = window.scrollY, dy = y - y0;
      if (Math.abs(dy) < 6) return;
      c.classList.toggle('agb-cizgi--acik', dy > 0 && y > 120);
      y0 = y;
    });
  }, { passive: true });
})();
